import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/app/environments/environments';
import { RemoteApiService } from 'src/app/shared/services/remote-api.service';

export interface ContactUsDialogData {
  email?: string;
  displayName?: string;
  store?: string;
  userId?: string;
}

@Component({
  selector: 'app-contact-us-dialog',
  templateUrl: './contact-us-dialog.component.html',
  styleUrls: ['./contact-us-dialog.component.scss'],
})
export class ContactUsDialogComponent {
  readonly supportEmail = 'support@conversell.ai';
  contactForm: FormGroup;
  isLoading = false;
  isSent = false;
  isError = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ContactUsDialogComponent>,
    private RAS: RemoteApiService,
    @Inject(MAT_DIALOG_DATA) public data: ContactUsDialogData,
  ) {
    this.contactForm = this.fb.group({
      email: [{ value: this.supportEmail, disabled: true }],
      description: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  private getContactApiUrl(): string {
    const workspace = String(environment.workspaceUrl || '').replace(/\/$/, '');
    if (workspace.includes('gateway')) {
      return `${workspace}/website/contact`;
    }
    return 'https://conversell-gateway-9og1b78t.uc.gateway.dev/website/contact';
  }

  onSend(): void {
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.isError = false;

    const description = String(this.contactForm.get('description')?.value || '').trim();
    const name = String(this.data.displayName || '').trim();
    const [firstname, ...lastNameParts] = name.split(/\s+/);
    const store = this.data.store || '';
    const replyTo = String(this.data.email || '').trim();
    const messageParts = [description];
    if (store) {
      messageParts.push(`Store: ${store}`);
    }

    const body = {
      firstname: firstname || 'User',
      lastname: lastNameParts.join(' '),
      email: replyTo || this.supportEmail,
      phonenumber: '',
      subject: 'Already a customer, need support team',
      message: messageParts.join('\n\n'),
      marketing: '1',
    };

    this.RAS.postApi(this.getContactApiUrl(), body).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res?.success === false || res?.status === 'failed' || res?.status === 'error') {
          this.isError = true;
          return;
        }
        this.isSent = true;
      },
      error: () => {
        this.isLoading = false;
        this.isError = true;
      },
    });
  }

  onRetry(): void {
    this.isError = false;
    this.isSent = false;
    this.isLoading = false;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
